import ReactSelect5, { Option, ReactSelect5Props } from './ReactSelect5';

export type { Option, ReactSelect5Props };

export default ReactSelect5;
